import "../styles/CommonFooter.css";

const CommonFooter = () => {
  return (
    <footer className="footer">
      {/* TOP CTA SECTION */}
      <div className="footer-cta">
        <div className="cta-left">
          <h2>
            Loved By Our <br /> Customers <span>✨</span>
          </h2>
          <p>
            Your vision deserves to stand out. We collaborate closely to
            transform your ideas into powerful visuals that connect, inspire,
            and drive results. From concept to creation, our team ensures every
            detail reflects your brand’s purpose and brings your story to life
            beautifully.
          </p>
        </div>

        <div className="cta-right">
          <input type="email" placeholder="Enter your email" />
          <textarea placeholder="Explain your idea in brief" />
          <button>Submit Request</button>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <div className="footer-brand">
          <h3>Vidify</h3>
          <span>© 2026 All Rights Reserved</span>
        </div>

        <div className="footer-links">
          <a href="#">Services</a>
          <a href="#">Case Studies</a>
          <a href="#">Contact</a>
        </div>
      </div>
    </footer>
  );
};

export default CommonFooter;
